import { createI18n } from 'vue-i18n'
const i18n = createI18n({
  locale: 'en',
  messages: {
    'en': {
      'ts_coin_text':"It's not just a digital currency; it's a comprehensive business project that combines innovation and opportunity within an integrated strategy to facilitate buying and selling within our market. It also represents an opportunity to achieve cumulative profits with each stage of growth. Furthermore, it's already being used in our real-world projects, such as commercial real estate, cafes, companies, schools, and institutions.",
    },
    'ar': {
      'Home':"الرئسية",
      'Contact us':"تواصل معنا",
      'Contact':"تواصل",
      'US!':"معنا!",
      'Terms of Use':"شروط الإستخدام",
      'Sign in Page':"صفحة تسجيل الدخول",
      'With Trends shift,':"مع  ترندز شفت",
      'We believe in a more beautiful future.':"نؤمن بمستقبل أكثر جمالاً.",
      'Together we determine the best direction.':"معًا نحدد الاتجاه الأفضل.",
      'With the right tools we provide to you.':"باستخدام الأدوات المناسبة التي نوفرها لك.",
      'Trends':"ترندز",
      'Shift can':"شفت بإمكانها",
      'Help':"أن تساعدك",
      'Talk to us':"تحدث معنا",
      'Full Name':"الاسم الكامل",
      'Email Address':"البريد الإلكتروني",
      'Your Message':"رسالتك",
      'Full Name is required':"الرجاء إدخال الاسم الكامل",
      'Email Address is required':"الرجاء إدخال البريد الإلكتروني",
      'Your Message is required':"الرجاء إدخال رسالتك",
      'Please enter valid email':"الرجاء التأكد من البريد الإلكتروني",
      'Submit':"إرسال",
      'Failed to send message please try again later':"فشل إرسال الرسالة الرجاء إعادة المحاولة لاحقاً",
      'Message sent successfully':"تم إرسال الرسالة بنجاح",
      'Terms and Conditions.':"الشروط والأحكام.",
      'Download PDF File':"تحميل الملف",
      'Create your account':"",
      'Fill the form below to create your account':"",
      'Type your full name':"أدخل اسمك الكامل",
      'Type your user name':"أدخل اسم المستخدم",
      'User Name':"اسم المستخدم", 
      'Create your account':"قم بإنشاء حسابك",
      'Fill the form below to create your account':"قم بملء النموذج أدناه لإنشاء حسابك",
      'Phone Number':"رقم الهاتف",
      'Type your phone number':"أدخل رقم الهاتف",
      'Type your password':"أدخل كلمة المرور",
      'Password':"كلمة المرور",
      'Confirm Password':"تأكيد كلمة المرور",
      'Refferral Link':"رابط الإحالة",
      'Next Step':"الخطوة التالية",
      'Type your email address':"أدخل بريدك الإلكتروني",
      'Password do not match':"كلمة المرور لا تتطابق",
      'Password must be at least 8 characters':"يجب أن تتكون كلمة المرور من 8 أحرف على الأقل",
      'Password is required':"الرجاء إدخال كلمة المرور",
      'Confirm Password is required':"الرجاء تأكيد كلمة المرور",
      'Phone Number is required':"الرجاء إدخال رقم الهاتف",
      'We need some information to verify your account':"نحن بحاجة إلى بعض المعلومات للتحقق من حسابك",
      'Back':"رجوع",
      'Create Account':"إنشاء حساب",
      'Date of Birth':"تاريخ الميلاد",
      'Date of Birth is required':"الرجاء إدخال تاريح الميلاد",
      'Address':"العنوان",
      'Address is required':"الرجاء إدخال العنوان",
      'Type your address':"أدخل عنوانك",
      'Profession':"المهنة",
      'Profession is required':"الرجاء إدخال المهنة",
      'Type your profession':"أدخل مهنتك",
      'Identification Type':"نوع بطاقة التعريف",
      'Identification Type is required':"الرجاء إختيار نوع بطاقة التعريف",
      'Passport':"جواز سفر",
      'Driving License':"شهادة سواقة",
      'Identification Number':"رقم بطاقة التعريف",
      'Identification Number is required':"الرجاء إدخال رقم بطاقة التعريف",
      'Type your identification number':"أدخل رقم بطاقة التعريف",
      'Identification Photo':"صورة بطاقة التعريف",
      'Identification Photo is required':" الرجاء تحميل بطاقة التعريف",
      'Upload a Selfie':"صورة سلفي",
      'Selfie is required':" الرجاء تحميل صورة سلفي",
      'Upload the document here':"قم بتحميل الملف هنا",
      'Max size is 5Mb':"الحجم الأقصى 5MB",
      'Max size is 3Mb':"الحجم الأقصى 3MB",
      'supported files':"الملفات المدعومة",
      'Under Review':"قيد المراجعة",
      'The information you uploaded is under review':"المعلومات التي قمت بتحميلها قيد المراجعة",
      'We will notify you when your account is ready and approved.':"سنقوم بإعلامك عندما يصبح حسابك جاهزًا ويتم الموافقة عليه.",
      'Go back home':"العودة إلى الرئيسية",
      'Email Address / Username':"البريد الإلكتروني / اسم المستخدم",
      'This field is required':"هذا الحقل إجباري",
      'Type your email/username':"اكتب بريدك الإلكتروني/اسم المستخدم",
      'Forgot password?':"نسيت كلمة المرور؟",
      'Sign in':"تسجل الدخول",
      'Failed to logged in please try again later':"فشل تسجيل الدخول الرجاء إعادة المحاولة لاحقاً",
      'Logged in success':"تم تسجيل الدخول بنجاح",
      'Failed to register please try again later':"فشل إنشاء الحساب الرجاء إعادة المحاولة",
      'First Name':"الاسم الأول",
      'First Name is required':"الرجاء إدخال الاسم الأول",
      'User Name is required':"الرجاء إدخال الاسم المستخدم",
      'Last Name is required':"الرجاء إدخال الاسم الأخير",
      'Last Name':"الاسم الأخير",
      'Type your first name':"أدخل اسمك الأول",
      'Type your last name':"أدخل اسمك الأخير",
      'The username has already been taken.':" اسسم المستخدم هذا مسجل مسبقاً",
      'The email has already been taken.':"البريد الإلكتروني مسجل مسبقاً.",
      'These credentials do not match our records':"إن البريد الإلكتروني او  كلمة السر لا يتطابق مع البينات لدينا",
      'Sign in to your account':"تسجيل الدخول إلى حسابك",
      'Terms & Condition':"الشروط والأحكام",
      'Trend Shift is a general trading company licensed in Lebanon, headquartered in Lebanon, with license number.':"تريند شيت هي شركة تجارية عامة مرخصة في لبنان، ومقرها الرئيسي في لبنان، برقم الترخيص.",
      'Our goal is to build the largest community of partners, including 100 Royal Ambassadors.':"هدفنا هو بناء أكبر مجتمع من الشركاء، بما في ذلك 100 سفير ملكي.",
      'We believe in a more beautiful future.':"نؤمن بمستقبل أكثر جمالا.",
      'Our Services':"خدمتنا",
      'Services':"خدمتنا",
      '':"",
      'Subscribe to our':"اشترك في",
      'premium services':"خدماتنا المميزة",
      'Commission':"العمولة",
      'how much do you make?':"كم تربح؟",
      'Contact us via Whatsapp':"تواصل معنا عبر الواتس اب",
      'Trends':"ترندز",
      'Signal':"سيجنال",
      'Join the group for the latest Trends signals':"انضم للمجموعة للحصول على أحدث الاتجاهات",
      'Join us via Whatsapp':"انضم إلينا عبر الواتس اب",
      'Referral Link':"رابط الإحالة",
      'Invalid invitation pin':"رمز الإحالة غير صحيح",
      'Logout':"تسجيل خروج",
      'Failed to get data please try again later':"فشل في الحصول على البيانات، يرجى المحاولة مرة أخرى لاحقًا",
      'Nationality is required':"الرجاء إختيار الجنسية",
      'Nationality':"الجنسية",
      'Dashboard':"لوحة التحكم",
      'Middle Name':"الاسم الاوسط",
      'Type your middle name':"أدخل الاسم الاوسط",
      'Middle Name is required':"الرجاء إدخال الاسم الاوسط",
      'ID':"الهوية",
      'Please read these terms and conditions carefully before using our platform.':"يرجى قراءة هذه الشروط والأحكام بعناية قبل استخدام منصتنا.",
      'Select Nationality':"إختر الجنسية",
      'Password reset link sent to your email':"تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",
      'Failed reset password please try again later':"فشلت عملية إعادة تعيين كلمة المرور، يرجى المحاولة مرة أخرى لاحقًا",
      'Social Media':"وسائل التواصل الاجتماعي",
      'I agree that my data will be securely stored and will not be used for any purpose other than account creation and management, and I agree to all the terms and conditions of the company.':"أوافق على أن بياناتي سيتم تخزينها بشكل آمن ولن يتم استخدامها لأي غرض آخر غير إنشاء الحساب وإدارته، و أوافق على كافة الشروط الأحكام الخاصة بالشركة.",
      'Change Password':"تغيير كلمة المرور",
      'Password changed succsefully':"تم تعديل كلمة المرور بنجاح",
      'Failed to change password please try again later':"فشل تغيير كلمة المرور الرجاء إعادة المحاولة لاحقاً",
      'Could not find this account':"لم يتم العثور على هذا البريد",
      'This link is invalid':"هذا الرابط غير صحيح",
      'This link is invalid, please check your email':"هذا الرابط غير صحيح، الرجاء التأكد من بريدك الإلكتروني",
      'Shift':" شفت",
      'Account verified and it is under review now':"تم توثيق الحساب وهو قيد المراجعة الآن",
      'Email Verfication sent':"تم إرسال بريد التوثيق",
      'Please check your email to verfiy your account':"الرجاء التأكد من بريدك الإلكتروني لتوثيق الحساب",
      'You are only allowed to enter characters from a to z and 0 to 9 and space':"يسمح لك بإدخال من a إلى z ومن 0 إلى 9 وفراغ بينهم",
      'You are only allowed to enter characters from a to z and 0 to 9 with no space':"يسمح لك بإدخال من a إلى z ومن 0 إلى 9 مع عدم وجود فراغات بينهم",
      'You are only allowed to enter characters from a to z and 0 to 9 and special characters with no space':"يسمح لك بإدخال من a إلى z ومن 0 إلى 9 وبعض الرموز مع عدم وجود بينهم",
      'You are only allowed to enter from 0 to 9 with no space':"يسمح لك إدخال من 0 إلى 9 مع عدم وجود فراغات بيتهم",
      'Contact us via whatsapp':"تواصل معنا الآن من خلال الواتس آب",
      'Support Line':"خط الدعم",
      'Funds':"الموارد المالية",
      'TrendsShif package':"باقات ترندشفت",
      'Team':"الفريق",
      'Ranks':"الرتب",
      'Commession/Profit':"عمولة/عوائد",
      'TrendsShift Academy':"أكادمية ترندشفت",
      'News & Tools':"أخبار وأدوات",
      'Start today, do not wait for tomorrow':"ابدأ اليوم ولا تنتظر الغد",
      'Member':"عضو",
      'Subscribe Now':"إشتراك الآن",
      'Can not take photo':"لم تتمكن من إلتقاط الصورة",
      'Take Photo':"إلتقاط صورة",
      'Retake Photo':"إعادة إلتقاط صورة",
      'Open Selfie Camera':"فتح الكاميرا الأمامية",
      'Sesssion expired':"لقد إنتهت الجلسة، الرجاء تسجيل الدخول من جديد",
      'Failed to get data, please refresh page after moment':"فشل الحصول على المعلومات، الرجاء إعادة تحديث الصفحة بعد لحظات",
      'TrendsShift Ranks Community':"ترقيات ترندز شفت",
      'Shares':"أسهم",
      'Total R-OV':"مجموع ال R-OV",
      'Growth Percentage':"نسبة النمو",
      'unit':"وحدة",
      'Total Commission':"مجموع العمولة",
      'Members':"الأعضاء",
      'Congratulation':"تهانينا",
      'This account is not active, please contact support team':"هذا الحساب غير مفعل يرجى التواصل معفريق الدعم",
      'Memebership Card Service':"خدمة بطاقة العضوية",
      'Please read these terms and services':"يرجى قراءة هذه الشروط والخدمات بعناية",
      'carefully before using our platform':"قبل استخدام منصتنا",
      'Valid For One Year':"صالحة لمدة عام",
      'Marketing Agency':"وكالة تسويق",
      'Billing System':"نظام فوترة",
      'Academy Trainings':"دورات تدريبية في الأكاديمية",
      'Customer Service':"خدمة العملاء",
      'Membership Card':"بطاقة العضوية",
      'Official Contract':"عقد رسمي",
      'Compensations Plan':"خطة التعويضات",
      'Referral Link':"رابط الإحالة",
      'Awards And Offers':"الجوائز والعروضات",
      'I agree the trems and srvices':"أوافق على الشروط والخدمات",
      'Accept':"أوافق",
      'Download PDF file':"تحميل الملف",
      'Get our premium services':"احصل على خدماتنا المتميزة",
      'per year':"سنوياً",
      'Great Deal':"صفقة عظيمة",
      'Payment':"دفعة",
      '1 User x $200':"1x $200 مستخدم ",
      'Pay today':"إدفع اليوم",
      'Billed to':"فاتورة بإسم",
      'Transfer Completion':"إتمام عملية التحويل",
      'In case your transfer was completed, you can easily apply upoad a screen shot below to verify payment':"في حالة اكتمال عملية التحويل الخاصة بك، يمكنك بسهولة تطبيق تحميل لقطة الشاشة أدناه للتحقق من الدفع",
      'Upload transfer screenshot':"تحميل صورة االتحويل",
      'Copy our receiving address':"إنسخ عنوان الإستلام",
      'Scan Qr code':"إمسح رمز Qr",
      'Scan the qr code to easily subscribe':"قم بمسح رمز Qr للاشتراك بسهولة",
      'Preview Image':"عرض الصورة",
      'Cancel':"إلغاء",
      'Confirm':"تأكيد",
      'Subsription request sent successfully':"تم إرسال طلب الاشتراك بنجاح",
      'Failed to send subsription request please try again later':"فشل في إرسال طلب الاشتراك، يرجى المحاولة مرة أخرى لاحقًا",
      'Copy wallet address':"إنسخ عنوان المحفظة",
      'Copy phone number':"إنسخ رقم الهاتف",
      'Packages':"الباقات",
      'Your Cart':"عربة التسوق الخاصة بك",
      'item':"الصنف",
      'price':"السعر",
      'quantity':"االكمية",
      'total':"المجموع",
      'Package removed from cart successfully':"تمت إزالة الحزمة من عربة التسوق بنجاح",
      'Failed to remove package from cart, please try again later':"فشل في إزالة الحزمة من عربة التسوق، يرجى المحاولة مرة أخرى لاحقًا",
      'Your Cart is empty':"سلة التسوق الخاصة بك فارغة",
      'Package add to cart successfully':"تمت إضافة الحزمة إلى عربة التسوق بنجاح",
      'Failed to add package to cart, please try again later':"فشلت عملية إضافة الحزمة إلى عربة التسوق، يرجى المحاولة مرة أخرى لاحقًا",
      'Cart updated successfully':"تم تحديث عربة التسوق بنجاح",
      'Failed to update cart, please try again later':"فشل تحديث عربة التسوق، يرجى المحاولة مرة أخرى لاحقًا",
      'Update Cart':"تحديث العربة",
      'Email or Username is required':"الرجاء إدخال البريد الإلكتروني أو اسم المستخدم",
      'success partner pool':"حوض شركاء النجاح",
      'Leadership Pool':"حوض القيادة",
      'Member Pool':"حوض الأعضاء",
      'Trends Shift Packges':"حزم ترندز شفت",
      'Aiz17 Packges':"باقات Aiz17",
      'Members Pool Packges':"باقات حوض الأعضاء",
      'Buy Now':"إشتري الآن",
      'My Profile':"ملفي الشخصي",
      'Personal Information':"المعلومات الشخصية",
      'Subscription Details':"تفاصيل الإشتراك",
      'Status':"الحالة",
      'Renewal Date':"تاريخ التجديد",
      'Edit':"تعديل",
      'Edit My Profile':"تعديل ملف التعريف الشخصي",
      'Update Profile':"تحديث الملف الشخصي",
      'Profile updated successfully':"تم تحديث الملف الشخصي بنجاح",
      'Failed to submit order, please try again later':"فشل في إرسال الطلب، يرجى المحاولة مرة أخرى لاحقًا",
      'Packages order submitted  successfully':"تم إرسال طلب الطرود بنجاح",
      'Current Rank':"الرتبة الحالية",
      'Aiz17':"Aiz17",
      'Digital Asset':"الأصول الرقمية",
      'Tripoli - Majida Center - 8th floor':"طرابلس - ماجدة سنتر - طابق الثامن",
      'Affiliate Marketing':"تسويق بالعمولة",
      'Project Finance & Development':"تمويل وتطوير المشاريع",
      'Training Academy':"أكاديمية التدريب",
      'Commercial projects':"مشاريع تجارية",
      'Digital Assets':"أصول رقمية",
      'Change Password':"تعديل كلمة المرور",
      'Back':"رجوع",
      'Old Password':"كلمة المرور القديمة",
      'New Password':"كلمة المرور الجديدة",
      'Confirm Password':"تأكيد كلمة المرور",
      'Old Password is required':"كلمة المرور القديمة مطلوبة",
      'New Password is required':"كلمة المرور الجديدة مطلوبة",
      'Change Image':"تغيير الصورة",
      'Image updated successfully':"تم تحديث الصورة بنجاح",
      'Failed to update image please try again later':"فشل تحديث الصورة، يُرجى المحاولة لاحقًا",
      'Academy Pool':"حوض الأكاديمية",
      'We are building a strong community of partners and Royal Ambassadors.':"نبني مجتمعًا قويًا من الشركاء والسفراء الملكيين.",
      'Let\'s shape a brighter future together.':"لنصنع معًا مستقبلًا أكثر إشراقًا.",
      'Villas\' Pool':"حوض الفلل",
      'Top up Pool':"حوض تعبئة البطاقة",
      'Top up':"تعبئة البطاقة",
      'Points':"نقاط",
      'Profile Picture':"الصورة الشخصية",
      'Villa Pool Packges':"حوض الفلل",
      'Academy Packges':"حوض الأكاديمية",
      'My Orders':"طلباتي",
      'Order Id':"رقم الطلب",
      'Order Type':"نوع الطلب",
      'Total Price':"السعر الكلي",
      'Total Unit':"عدد الوحدات",
      'Status':"الحالة",
      'Order Date':"تاريخ الطلب",
      'Action':"إجراء",
      'per page':"في الصفحة",
      'Prev':"السابق",
      'Next':"التالي",
      'of':"من",
      'page':"صفحة",
      'There is no order':"لا يوجد طلبات",
      'Subscribe to your':"إشترك في",
      'Referral Link':"رابط الإحالة",
      'Referral Link Now':"رابط الأحالة الخاص بك",
      'For only':"فقط بـ",
      'Waiting Payment':"بإنتظار الدفع",
      'Paid':"مدفوع",
      'Accepted':"مقبول",
      'Rejected':"مرفوض",
      'View More':"للمزيد",
      'Amount':"المبلغ",
      'Payment success':"تم الدفع بنجاح",
      'Payment failed, please try again later':"فشل الدفع، يرجى المحاولة لاحقًا",
      'My Billings':"فواتيري",
      'There is no billings':"لا توجد فواتير",
      'TS8 Pool':"حوض TS8",
      'Total Unit':"إجمالي الوحدات",
      'Complete payment':"إكمال الدفع",
      'Approved':"مقبول",
      'Billing Type':"نوع الفاتورة",
      'Billing Date':"تاريخ الفاتورة",
      'Receipt Image':"صورة الإيصال",
      'You have successfully completed your purchase.':"لقد قمت بإتمام عملية الشراء بنجاح.",
      "You can view your unit on the company's website.":"يمكنكم الإطلاع على اليونت الخاصة بكم داخل موقع الشركة.",
      "You can also track the number of coins you hold on your wallet, which is connected to the company's main wallet.":"كما يطكنكم متابعة عدد العملات الخاصة بكم على محفظتكم المتصلة محفظة الشركة الرئيسة .",
      'Together towards the better direction':"معاً نحوالإتجاه الأفضل",
      'Dear':"عزيزي",
      'Invoice':"فاتورة",
      'TrendShift Market':"سوق TrendShift",
      'Buy TS8':"اشتري TS8",
      'TS8 Packgers can be caneled and refund within 24 hours':"يمكن إلغاء حزم TS8 واستردادها المبلغ المدفوع خلال 24 ساعة.",
      'Orders & Billings':"الطلبات والفواتير",
      'Whatsapp':"واتساب",
      'Email':"البريد الإلكتروني",
      'Menu':"القائمة",
      'Digital Currency':"عملة رقمية",
      'Market':"السوق",
      'Signals':"الإشارات",
      'Academy':"الأكاديمية",
      'Real Estate Fund':"عالم العقارات",
      'For Inquiries':"للاستفسارات",
      'Tripoli - Lebanon':"طرابلس - لبنان",
      'Follow Us:':"تابعنا:",
      'Buying & Selling':"شراء وبيع",
      'Brokerage':"وساطة",
      'Online Marketing':"التسويق عبر الإنترنت",
      'Main Activities':"الأنشطة الرئيسية",
      'Membership':"العضوية",
      'we believe in a more beautiful future':"نحن نؤمن بمستقبل أكثر جمالًا",
      'Together We Determine The Best Direction':"معًا نحدد الاتجاه الأفضل",
      'More Info':"المزيد",
      'We Believe In A More Beautiful Future':"نحن نؤمن بمستقبل أكثر جمالًا",
      'Together We Determine The Best Direction':"معًا نحدد الاتجاه الأفضل",
      'Trends Shift is a trading company licensed in Lebanon with license number 3024596, headquartered in Lebanon.':"تراند شيفت شركة تجارية مرخصة في لبنان رقم السجل: ٣٠٢٤٥٩٦ مقرها الرئيس في قضاء لبنان الشمالي محافظة طرابلس.",
      'Its main activities include: buying and selling, brokerage, and online marketing.':"من أهم نشاطاتها: البيع والشراء، الوساطة وعمليات التسويق عبر الإنترنت.",
      'Training & Development':"تدريب و تطوير",
      'Affiliate':"رابط إحالة",
      'Per Year':"في السنة",
      'golden':"golden",
      'vip':"vip",
      'basic':"basic",
      'pro':"pro",
      'PLANS & RANKS':"الخطط والترقيات",
      'Bonus in success partner pool':"بونص في حوض شركاء النجاح",
      'TS8 Net Profit':"صافي أرباح TS8",
      'More value for less price':"قيمة أكبر بسعر أقل",
      'TS8 Capital':"رأس مال TS8",
      'Activities':"الأنشطة",
      'Membership':"العضوية",
      'Digital currency':"العملة الرقمية",
      'TS8 COIN':"عملة TS8",
      'ts_coin_text':"إنها ليست مجرد عملة رقمية، بل هي مشروع تجاري متكامل يجمع بين الإبتكار والفرص ،ضمن استراتيجية متكاملة تُسهّل عمليات البيع والشراء داخل سوقنا. كما تمثل فرصة لتحقيق أرباح تراكمية مع كل مرحلة نمو تُحققها. إضافةً إلى ذلك، فهي تُستخدم فعليًا في مشاريعنا الواقعية، مثل العقارات التجارية، المقاهي، الشركات، المدارس، والمؤسسات.",
      'TS8 Packages':"باقات TS8",
      'Price':"السعر",
      'Liquidity':"السيولة",
      'Market Cap':"القيمة السوقية",
      'Market':"السوق",
      'Support':"الدعم",
      'TrendsShift':"تراندز شيفت",
      'TrendsShift Memberships in one picture':"عضويات TrendsShift في صورة واحدة!",
      'Each membership grants you a comprehensive package of exclusive services and benefits carefully designed to support your financial journey.':"كل عضوية تمنحكم باقة متكاملة من الخدمات والمزايا الحصرية المصممة بعناية لدعم مسيرتكم المالية",
      'Join the ongoing journey of success with the progressive promotion system, starting from the Spark rank and culminating in Royal Ambassador, with each stage opening up broader horizons for achieving your financial goals and benefiting from exclusive advantages.':"انضم إلى مسيرة النجاح المستمرة مع نظام الترقيات التدريجي، الذي يبدأ من رتبة Spark حتى يصل إلى Royal Ambassador، مع كل مرحلة تفتح أمامك آفاقاً أوسع لتحقيق أهدافك المالية والاستفادة من المزايا الحصرية",
      'TS8 Price:':"سعر TS8:",
      'TS8 For Market Use':"TS8 للإستخدام في السوق",
      'No packages found in this category':"لا توجد باقات في هذه الفئة",
      'Leadership Ranks Pool':"حوض الرتب القيادة",
      'Your information will be securely stored and will not be used for any purpose other than account creation and management.':"سيتم تخزين معلوماتك بأمان ولن يتم استخدامها لأي غرض آخر غير إنشاء الحساب وإدارته.",
      'I agree to all the terms and conditions of the company.':"أوافق على جميع الشروط والأحكام الخاصة بالشركة.",
      'Memberships':"العضوية",
      'Buy Vip Membership':"اشتري عضوية VIP",
      'Buy Membership':"اشتري العضوية",
      '':"",
      '':"",
    },
  },
})
export default i18n
